import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useSession } from '@/hooks/authHooks';
import { isAdminRole } from '@/utils/auth';

interface RequireAdminProps {
  children: React.ReactNode;
}

export function RequireAdmin({ children }: RequireAdminProps) {
  const { user, isPending } = useSession();
  const router = useRouter();

  useEffect(() => {
    if (!isPending && user && !isAdminRole(user.role)) {
      router.navigate({ to: '/' });
    }
  }, [isPending, user, router]);

  if (isPending) {
    return null;
  }

  if (!user || !isAdminRole(user.role)) {
    return null;
  }

  return <>{children}</>;
}
